/**
 * 连线题
 */
import QuestionPair from './view';
import './index.less';

export default QuestionPair;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/pair/index.js